import React, { useState, useEffect } from 'react';
import { Pencil, Trash2, Plus, Package, Tag } from 'lucide-react';
import { getAllEquipment, deleteEquipment } from '../../../services/equipment';
import LoadingSpinner from '../../shared/LoadingSpinner';
import './EquipmentList.css';

const EquipmentList = ({ onEdit, onAdd }) => {
  const [equipment, setEquipment] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    loadEquipment();
  }, []);

  const loadEquipment = async () => {
    setLoading(true);
    const result = await getAllEquipment();
    if (result.success) {
      setEquipment(result.data);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    const result = await deleteEquipment(id);
    if (result.success) {
      setEquipment(equipment.filter(item => item.id !== id));
      setDeleteConfirm(null);
    } else {
      alert('Error deleting equipment: ' + result.error);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (equipment.length === 0) {
    return (
      <div className="admin-empty-state">
        <div className="admin-empty-icon">
          <Package size={64} />
        </div>
        <h3 className="admin-empty-title">No Equipment Yet</h3>
        <p className="admin-empty-text">
          Get started by adding your first equipment item.
        </p>
        <button onClick={onAdd} className="btn btn-primary">
          <Plus size={20} />
          Add First Equipment
        </button>
      </div>
    );
  }

  return (
    <div className="equipment-list">
      <div className="admin-cards-grid">
        {equipment.map((item) => (
          <div key={item.id} className="admin-item-card">
            <div className="admin-card-image">
              {item.image ? (
                <img src={item.image} alt={item.name} />
              ) : (
                <div className="admin-card-placeholder">
                  <Package size={32} />
                </div>
              )}
              <span className={`card-status-badge ${item.available ? 'available' : 'unavailable'}`}>
                {item.available ? 'Available' : 'Unavailable'}
              </span>
            </div>
            <div className="admin-card-content">
              <h3 className="admin-card-title">{item.name}</h3>
              <p className="admin-card-subtitle">{item.brand}</p>
              <div className="admin-card-meta">
                <span className="meta-item">
                  <Tag size={14} />
                  {item.category}
                </span>
              </div>
              <div className="admin-card-footer">
                <span className="admin-card-price">${item.price}/day</span>
                <div className="admin-card-actions">
                  <button
                    onClick={() => onEdit(item)}
                    className="btn btn-ghost btn-sm"
                    title="Edit"
                  >
                    <Pencil size={16} />
                  </button>
                  <button
                    onClick={() => setDeleteConfirm(item.id)}
                    className="btn btn-danger btn-sm"
                    title="Delete"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">Confirm Delete</h3>
            <p className="modal-text">
              Are you sure you want to delete this equipment? This action cannot be undone.
            </p>
            <div className="modal-actions">
              <button
                onClick={() => setDeleteConfirm(null)}
                className="btn btn-ghost"
              >
                Cancel
              </button>
              <button
                onClick={() => handleDelete(deleteConfirm)}
                className="btn btn-danger"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EquipmentList;
